module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (typeof(options) == "undefined") { var options = {}; } 
    ; __append("\n")
    ;  var checked = options.checked ? options.checked : [] 
    ; __append("\n")
    ;  if (type == "enum") { 
    ; __append("\n")
    ;  collection.each(function (value) { 
    ; __append("\n<label><input type=\"checkbox\" data-column=")
    ; __append(escapeFn( options["column"] ))
    ; __append("\n              value=\"")
    ; __append(escapeFn( value ))
    ; __append("\" on-click=\"")
    ; __append(escapeFn( options["on-click"] ))
    ; __append("\" ")
    ; __append(escapeFn( ~checked.indexOf(+value) ? "checked" : "" ))
    ; __append("><span>")
    ; __append(escapeFn( Html.encode(collection.title(value)) ))
    ; __append("</span></label>\n")
    ;  }) 
    ; __append("\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}